
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-can-use",
      function () {
        return require("private-next-pages/who-can-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-can-use"])
      });
    }
  